const isLocal = typeof window !== 'undefined' && window.location.hostname === '0.0.0.0';

export const API_ENDPOINT = isLocal
   ? 'https://beta.br.capacity-central.amzl.amazon.dev'
   : '';

export const STAGE = (() => {
   const config: Record<string, string> = typeof (globalThis as any).__CONFIG__ !== 'undefined'
       ? (globalThis as any).__CONFIG__
       : {};
   return config.Stage || 'beta';
})();

export function getCurrentUser(): string {
   console.log('cookies:', document.cookie);
   const match = document.cookie.match(/(?:^|;\s*)midway-auth-user=([^;]+)/);
   return match ? decodeURIComponent(match[1]) : 'unknown';
}

export const REGION = STAGE === 'prod' ? 'us-west-2' : 'us-west-2';
export const MARKETPLACE = 'jp';

export const API_STAGE = STAGE === 'prod' ? 'prod-fe' : 'beta';

export const CONFIG_TABLE = `fortaleza-${STAGE}-config`;
export const NODE_CONFIG_TABLE = `fortaleza-${STAGE}-node-config`;
export const CAP_RELEASE_CONFIG_TABLE = `fortaleza-${STAGE}-cap-release-config`;
export const CAP_RELEASE_CONFIGURATIONS_TABLE = `fortaleza-${STAGE}-cap-release-configurations`;
export const DS_AMZL_INPUT_TABLE = `fortaleza-${STAGE}-ds-input`;
export const DS_SSD_INPUT_TABLE = `fortaleza-${STAGE}-ssd-ds-input`;
export const DS_SSD_REFERENCE_TABLE = `fortaleza-${STAGE}-ssd-otr-reference-ds`;
export const DS_SSD_CAP_UPLIFT_TABLE = `fortaleza-${STAGE}-ssd-cap-uplift-ds-input`;
export const DS_CAP_UPLIFT_TABLE = `fortaleza-${STAGE}-cap-uplift-ds-input`;
export const DS_SPEED_CAP_UPLIFT_TABLE = `fortaleza-${STAGE}-speed-cap-ds-input`;
export const TACTICAL_CAPS_TABLE = `fortaleza-${STAGE}-tactical-caps`;
export const BATCH_EVENT_TABLE = `fortaleza-${STAGE}-batch-events`;
export const S3_BUCKET = `fortaleza-${STAGE}-do-not-delete`;